var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMoneyIn40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moneyin40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "piggy-bank",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bank",
    stroke: "#4F4D4C",
    fill: "#FFFFFF",
    x: 0.5,
    y: 6.5,
    width: 30,
    height: 24,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13.7380952,
    x2: 23,
    y2: 13.7380952,
    id: "slot",
    stroke: "#4F4D4C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(9.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shape",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(4.875000, 2.166667)",
    stroke: "#4F4D4C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.04166667 L2.16779706,7.04166667 M1.89583333,4.33333333 L1.35416667,4.33333333 M1.08220294,1.625 L3.25,1.625",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35416667,1.625 C0.606281068,1.625 0,2.23128107 0,2.97916667 C0,3.72705227 0.606281068,4.33333333 1.35416667,4.33333333 L1.35416667,4.33333333",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25,4.33333333 C2.5021144,4.33333333 1.89583333,4.9396144 1.89583333,5.6875 C1.89583333,6.4353856 2.5021144,7.04166667 3.25,7.04166667",
    id: "Curve-bottom",
    transform: "translate(2.572917, 5.687500) scale(-1, 1) translate(-2.572917, -5.687500) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.625,
    y1: 1.625,
    x2: 1.625,
    y2: 0,
    id: "Stick-top"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.625,
    y1: 8.66666667,
    x2: 1.625,
    y2: 7.04166667,
    id: "Stick-bottom"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMoneyIn40);
export default __webpack_public_path__ + "static/media/pictogramMoneyIn40.310b8cfe3b7ce28fcec201837c931e00.svg";
export { ForwardRef as ReactComponent };